// AUTO-GENERATED GraphQL Builder for LedgerEntry
import * as Builders from '../';
export class LedgerEntryBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  bookingId(){ return this.add('bookingId'); }
  guaranteeFundId(){ return this.add('guaranteeFundId'); }
  bookingPackageId(){ return this.add('bookingPackageId'); }
  vendorId(){ return this.add('vendorId'); }
  entryType(){ return this.add('entryType'); }
  amount(){ return this.add('amount'); }
  description(){ return this.add('description'); }
  invoiceId(){ return this.add('invoiceId'); }
  paymentId(){ return this.add('paymentId'); }
  entryDate(){ return this.add('entryDate'); }
  settled(){ return this.add('settled'); }
  bankRef(){ return this.add('bankRef'); }
  settledDate(){ return this.add('settledDate'); }
  direction(){ return this.add('direction'); }
  method(){ return this.add('method'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  booking(b?:(q:Builders.BookingBuilder)=>void){
    if(this.depth>=5||this.v.has('booking'))return this;
    this.v.add('booking');
    const n=new Builders.BookingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`booking { ${inner} }`);
    return this;
  }

  bookingPackage(b?:(q:Builders.BookingPackageBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingPackage'))return this;
    this.v.add('bookingPackage');
    const n=new Builders.BookingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackage { ${inner} }`);
    return this;
  }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  guaranteeFund(b?:(q:Builders.GuaranteeFundBuilder)=>void){
    if(this.depth>=5||this.v.has('guaranteeFund'))return this;
    this.v.add('guaranteeFund');
    const n=new Builders.GuaranteeFundBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`guaranteeFund { ${inner} }`);
    return this;
  }

  invoice(b?:(q:Builders.InvoiceBuilder)=>void){
    if(this.depth>=5||this.v.has('invoice'))return this;
    this.v.add('invoice');
    const n=new Builders.InvoiceBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`invoice { ${inner} }`);
    return this;
  }

  payment(b?:(q:Builders.PaymentBuilder)=>void){
    if(this.depth>=5||this.v.has('payment'))return this;
    this.v.add('payment');
    const n=new Builders.PaymentBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`payment { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }

  vendor(b?:(q:Builders.VendorBuilder)=>void){
    if(this.depth>=5||this.v.has('vendor'))return this;
    this.v.add('vendor');
    const n=new Builders.VendorBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendor { ${inner} }`);
    return this;
  }
}
